// removed by extract-text-webpack-plugin
module.exports = {"sectionTitle":"src-styles----archive-module---sectionTitle---1gyeo","eventInfo":"src-styles----archive-module---eventInfo---2AlJk","tags":"src-styles----archive-module---tags---12K3r","topic":"src-styles----archive-module---topic---1cWQe","category":"src-styles----archive-module---category---mr_sI","activeCategory":"src-styles----archive-module---activeCategory---2ZyWZ"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/archive.module.scss
// module id = 71
// module chunks = 106735565224735 162114328119038